import { useEffect, useState } from "react";
import { FaPrint, FaXmark } from "react-icons/fa6";

const PAPER_SIZES = [
    { value: "A4", label: "A4 (210 x 297 mm)" },
    { value: "A5", label: "A5 (148 x 210 mm)" },
    { value: "Letter", label: "Letter (216 x 279 mm)" },
    { value: "Legal", label: "Legal (216 x 356 mm)" },
];

const VOUCHER_TEMPLATES = [
    { value: "standard", label: "Standar (Detail)" },
    { value: "minimal", label: "Minimalis (User & Pass)" },
    { value: "card", label: "Kartu (Style Border)" },
    { value: "custom_card", label: "Kartu Kustom (Warna)" }, // <-- TAMBAHAN BARU
];

export const PrintConfigModal = ({ open, setOpen, onPrint, selectedCount }) => {
    const [config, setConfig] = useState({
        columns: 4,
        paperSize: "A4",
        template: "custom_card", // Default ke kartu kustom
    });

    useEffect(() => {
        if (open) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "";
        return () => { document.body.style.overflow = ""; };
    }, [open]);

    const selectStyle = "w-full px-3 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all appearance-none cursor-pointer";
    const selectArrow = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%2394a3b8' viewBox='0 0 16 16'%3E%3Cpath d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E")`;


    

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setOpen(false)} />
            <div className="relative w-full max-w-lg rounded-2xl shadow-2xl"
                style={{ background: "rgba(15,23,42,0.98)", border: "1px solid rgba(51,65,85,0.4)", backdropFilter: "blur(20px)" }}>

                {/* Header */}
                <div className="flex items-center justify-between px-6 py-5" style={{ borderBottom: "1px solid rgba(51,65,85,0.25)" }}>
                    <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: "rgba(139,92,246,0.12)", border: "1px solid rgba(139,92,246,0.2)" }}>
                            <FaPrint className="text-sm text-violet-400" />
                        </div>
                        <div>
                            <h3 className="font-bold text-gray-100 text-sm">Konfigurasi Cetak Voucher</h3>
                            <p className="text-[10px] text-slate-500 mt-0.5">{selectedCount > 0 ? `${selectedCount} voucher dipilih` : 'Semua voucher di halaman ini'}</p>
                        </div>
                    </div>
                    <button onClick={() => setOpen(false)} className="p-2 rounded-xl text-slate-400 hover:text-white hover:bg-white/10 transition-all">
                        <FaXmark size={18} />
                    </button>
                </div>

                {/* Body */}
                <div className="px-6 py-6 space-y-5">
                    {/* Grid Columns */}
                    <div>
                        <label className="block text-[10px] text-slate-500 font-semibold mb-2 uppercase tracking-wider">Jumlah Kolom (Grid)</label>
                        <div className="flex gap-2">
                            {[2, 3, 4].map((col) => (
                                <button key={col} type="button"
                                    onClick={() => setConfig(c => ({ ...c, columns: col }))}
                                    className="flex-1 py-2.5 rounded-xl text-sm font-semibold border transition-all"
                                    style={{
                                        background: config.columns === col ? "rgba(139,92,246,0.12)" : "rgba(30,41,59,0.6)",
                                        borderColor: config.columns === col ? "rgba(139,92,246,0.3)" : "rgba(51,65,85,0.4)",
                                        color: config.columns === col ? "#a78bfa" : "#94a3b8"
                                    }}>
                                    {col} Kolom
                                </button>
                            ))}
                        </div>
                    </div>

                    <div style={{ borderTop: "1px dashed rgba(51,65,85,0.25)" }} />

                    {/* Paper Size */}
                    <div>
                        <label className="block text-[10px] text-slate-500 font-semibold mb-2  tracking-wider">Ukuran Kertas (Untuk Sementara hanya 1 opsi)</label>
                        <select disabled value={config.paperSize} onChange={(e) => setConfig(c => ({ ...c, paperSize: e.target.value }))}
                            className={`${selectStyle}`} style={{ backgroundImage: selectArrow, backgroundRepeat: "no-repeat", backgroundPosition: "right 12px center" }}>
                            {PAPER_SIZES.map((ps) => <option key={ps.value} value={ps.value}>{ps.label}</option>)}
                        </select>
                    </div>

                    <div style={{ borderTop: "1px dashed rgba(51,65,85,0.25)" }} />

                    {/* Template */}
                    {/* <div>
                        <label className="block text-[10px] text-slate-500 font-semibold mb-2 uppercase tracking-wider">Template Voucher</label>
                        <div className="grid grid-cols-2 gap-2">
                            {VOUCHER_TEMPLATES.map((tpl) => (
                                <button key={tpl.value} type="button"
                                    onClick={() => setConfig(c => ({ ...c, template: tpl.value }))}
                                    className="py-2.5 rounded-xl text-[11px] font-semibold border transition-all"
                                    style={{
                                        background: config.template === tpl.value ? "rgba(139,92,246,0.12)" : "rgba(30,41,59,0.6)",
                                        borderColor: config.template === tpl.value ? "rgba(139,92,246,0.3)" : "rgba(51,65,85,0.4)",
                                        color: config.template === tpl.value ? "#a78bfa" : "#94a3b8"
                                    }}>
                                    {tpl.label}
                                </button>
                            ))}
                        </div>
                    </div> */}
                </div>

                {/* Footer */}
                <div className="flex gap-3 px-6 py-4" style={{ borderTop: "1px solid rgba(51,65,85,0.25)" }}>
                    <button type="button" onClick={() => setOpen(false)}
                        className="flex items-center justify-center gap-2 flex-1 px-4 py-2.5 rounded-xl text-sm font-semibold border transition-all"
                        style={{ background: "rgba(51,65,85,0.15)", borderColor: "rgba(51,65,85,0.3)", color: "#94a3b8" }}>
                        Batal
                    </button>
                    <button type="button" onClick={() => onPrint(config)}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold text-white bg-violet-600 hover:bg-violet-500 transition-all shadow-lg shadow-violet-600/20">
                        <FaPrint size={13} /> Cetak
                    </button>
                </div>
            </div>
        </div>
    );
};